module.exports = __webpack_public_path__ + "img/favicon-96x96.030a0fb.png";